import React from 'react';

import { SVGComponentProps } from './svg.types';

const NumberSVG = ({ size = '1em', ...otherProps }: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill="white" />
      <rect x="3" y="15" width="18" height="1" fill="#BCBEC2" />
      <rect x="3" y="17" width="18" height="1" fill="#BCBEC2" />
      <rect x="11" y="19" width="10" height="1" fill="#BCBEC2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 11.5C14 11.7761 14.2239 12 14.5 12C14.7761 12 15 11.7761 15 11.5V10H17V11.5C17 11.7761 17.2239 12 17.5 12C17.7761 12 18 11.7761 18 11.5V10H19.5C19.7761 10 20 9.77614 20 9.5C20 9.22386 19.7761 9 19.5 9H18V7H19.5C19.7761 7 20 6.77614 20 6.5C20 6.22386 19.7761 6 19.5 6H18V4.5C18 4.22386 17.7761 4 17.5 4C17.2239 4 17 4.22386 17 4.5V6H15V4.5C15 4.22386 14.7761 4 14.5 4C14.2239 4 14 4.22386 14 4.5V6H12.5C12.2239 6 12 6.22386 12 6.5C12 6.77614 12.2239 7 12.5 7H14V9H12.5C12.2239 9 12 9.22386 12 9.5C12 9.77614 12.2239 10 12.5 10H14V11.5ZM17 7H15V9H17V7Z"
        fill="#55585E"
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke="#D5D7DD" />
    </svg>
  );
};

export default NumberSVG;
